import BaseModal from '@/vcs/_shared/modals/BaseModal.vue'
import axios from 'axios'

export default {
  name: 'ShowCpMapModal',
  extends: BaseModal,
  data: function () {
    return {
      mapImageUrl: '',
    }
  },
  mounted() {
    this.fetchCpMapData(this.data.cpId)
  },
  components: {
    Blocker: () => import('@/vcs/_shared/blocker/cmp.vue'),
    CpuWireframe: () => import('@/vcs/_shared/cpu-wireframe/cmp.vue'),
  },
  methods: {
    fetchCpMapData() {
      axios({
        method: 'get',
        url: `collection_points/${this.data.cpId}/map_image_url`,
      })
        .then(response => {
          this.mapImageUrl = response.data.mapImageUrl
        })
        .catch(error => {
          this.$errorHumanized({ error })
        })
    },
  },
}
